module.exports = __webpack_public_path__ + "static/media/users.d1ceebba.svg";